module.exports = __webpack_public_path__ + "static/media/icon_clip.0902f36b.svg";